import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { useLayoutEffect, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import cx from 'classnames'

import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
var t = i18n.getFixedT(null, 'setting-mape');
var MapeTerminalChart = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      terminalsMapeByWeek = _useSelector.mape.terminalsMapeByWeek;

  var dispatch = useDispatch();
  var chartXY = useRef();
  var categoryAxis = useRef();
  var dayAryT = ['lbl-mon', 'lbl-tue', 'lbl-wed', 'lbl-thu', 'lbl-fri', 'lbl-sat', 'lbl-sun'];

  var handleChartData = function handleChartData() {
    if (_.isEmpty(terminalsMapeByWeek)) return [];
    var chartData = [];
    terminalsMapeByWeek.map(function (el) {
      var d = _.map(el.data, function (o) {
        return {
          category: dayAryT[el.day - 1] + '_' + o.time,
          day: t(dayAryT[el.day - 1]),
          time: o.time,
          mape: Math.round(o.mape * 100 * 10) / 10,
          avgDuration: o.avgDuration,
          avgEstVisitDuration: o.avgEstVisitDuration
        };
      });

      chartData = [].concat(_toConsumableArray(chartData), _toConsumableArray(d)); // Create x-axis range

      var range = categoryAxis.current.axisRanges.create();
      range.category = d[0].category;
      range.endCategory = d[d.length - 1].category;
      range.label.text = d[0].day;
      range.label.dy = 30; // Control range label position y-axis

      range.label.truncate = true;
      range.label.fontWeight = 'bold';
      range.label.tooltipText = d[0].day;
      range.label.adapter.add("maxWidth", function (maxWidth, target) {
        var range = target.dataItem;
        var startPosition = categoryAxis.current.categoryToPosition(range.category, 0);
        var endPosition = categoryAxis.current.categoryToPosition(range.endCategory, 1);
        var startX = categoryAxis.current.positionToCoordinate(startPosition);
        var endX = categoryAxis.current.positionToCoordinate(endPosition);
        return endX - startX;
      });
    });
    return chartData;
  };

  var handleTimeText = function handleTimeText(time) {
    return (time < 10 ? '0' + time : time) + ':00';
  };

  useLayoutEffect(function () {
    chartXY.current = am4core.create('mape-terminal-chart', am4charts.XYChart);
    chartXY.current.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chartXY.current.leftAxesContainer.layout = 'vertical'; // Create axes

    categoryAxis.current = chartXY.current.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.current.dataFields.category = 'category';
    categoryAxis.current.dataItems.template.text = '{time}';
    categoryAxis.current.renderer.grid.template.location = 0;
    categoryAxis.current.renderer.minGridDistance = 18;
    categoryAxis.current.adapter.add("tooltipText", function (tooltipText, target) {
      return categoryAxis.current.tooltipDataItem.dataContext.day + ' ' + handleTimeText(categoryAxis.current.tooltipDataItem.dataContext.time);
    }); // categoryAxis.current.renderer.cellStartLocation = 0.2
    // categoryAxis.current.renderer.cellEndLocation = 0.8
    // Set chart 1

    var valueAxis = chartXY.current.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = t('lbl-avg-duration');
    valueAxis.height = am4core.percent(50);
    valueAxis.renderer.minGridDistance = 50;
    valueAxis.min = 0;
    var series = chartXY.current.series.push(new am4charts.LineSeries());
    series.dataFields.categoryX = 'category';
    series.dataFields.valueY = 'avgDuration';
    series.tooltipText = "".concat(t('lbl-real-value'), ":{valueY}");
    series.strokeWidth = 2;
    var series2 = chartXY.current.series.push(new am4charts.LineSeries());
    series2.dataFields.categoryX = 'category';
    series2.dataFields.valueY = 'avgEstVisitDuration';
    series2.tooltipText = "".concat(t('lbl-predicted-value'), ":{valueY}");
    series2.strokeWidth = 2; // Set chart 2 

    var valueAxis2 = chartXY.current.yAxes.push(new am4charts.ValueAxis());
    valueAxis2.height = am4core.percent(50);
    valueAxis2.title.text = t('lbl-mape-percent');
    valueAxis2.marginTop = 30;
    valueAxis2.min = 0;
    var series3 = chartXY.current.series.push(new am4charts.ColumnSeries());
    series3.dataFields.categoryX = 'category';
    series3.dataFields.valueY = 'mape';
    series3.yAxis = valueAxis2;
    series3.columns.template.strokeOpacity = 0;
    series3.columns.template.tooltipText = "MAPE:{valueY}%";
    series3.columns.template.adapter.add("fill", function (fill, target) {
      if (target.dataItem && target.dataItem.valueY >= 34 && target.dataItem.valueY < 67) return am4core.color('#ffbc3c');else if (target.dataItem && target.dataItem.valueY >= 67) return am4core.color('#ff3c3c');else return am4core.color('#55c836');
    }); // // range grid
    // var rangeTemplate = categoryAxis.current.axisRanges.template;
    // rangeTemplate.tick.disabled = false;
    // rangeTemplate.tick.location = 0;
    // rangeTemplate.tick.strokeOpacity = 1;
    // rangeTemplate.tick.length = 5;
    // rangeTemplate.grid.strokeOpacity = 0.2;
    // rangeTemplate.label.tooltip = new am4core.Tooltip();
    // rangeTemplate.label.tooltip.dy = -10;
    // rangeTemplate.label.cloneTooltip = false;
    // const dayAryT = ['lbl-mon', 'lbl-tue', 'lbl-wed', 'lbl-thu', 'lbl-fri', 'lbl-sat', 'lbl-sun']
    // let chartData = []
    // data.map(el => {
    //     let d = _.map(el.data, o => ({
    //             category: dayAryT[el.day - 1] + '_' + o.time,
    //             day: t(dayAryT[el.day - 1]),
    //             time: o.time,
    //             mape: o.mape,
    //             avgDuration: o.avgDuration,
    //             avgEstVisitDuration: o.avgEstVisitDuration
    //         })
    //     )
    //     chartData = [ ...chartData, ...d]
    //     // Create x-axis range
    //     let range = categoryAxis.current.axisRanges.create()
    //     range.category = d[0].category
    //     range.endCategory = d[d.length - 1].category
    //     range.label.text = d[0].day
    //     range.label.dy = 30 // Control range label position y-axis
    //     range.label.truncate = true
    //     range.label.fontWeight = 'bold'
    //     range.label.tooltipText = d[0].day
    //     range.label.adapter.add("maxWidth", (maxWidth, target) => {
    //         let range = target.dataItem
    //         let startPosition = categoryAxis.current.categoryToPosition(range.category, 0)
    //         let endPosition = categoryAxis.current.categoryToPosition(range.endCategory, 1)
    //         let startX = categoryAxis.current.positionToCoordinate(startPosition)
    //         let endX = categoryAxis.current.positionToCoordinate(endPosition)
    //         return endX - startX
    //     })
    // })

    chartXY.current.cursor = new am4charts.XYCursor(); // chartXY.current.data = chartData
    // Hide amcharts4 logo

    var eles = document.querySelectorAll('[aria-labelledby$=-title]');
    eles.forEach(function (ele) {
      ele.style.visibility = 'hidden';
    });
    return function () {
      chartXY.current.dispose();
    };
  }, []);
  useEffect(function () {
    chartXY.current.data = handleChartData();
  }, [JSON.stringify(terminalsMapeByWeek)]);
  return /*#__PURE__*/React.createElement("div", {
    id: "mape-terminal-chart",
    className: "chart"
  });
});
export default MapeTerminalChart;